import { CommandGetAd } from "./commands/cmdGetAd";
import { CommandGetAdComments } from "./commands/cmdGetAdComments";
import { CommandListAds } from "./commands/cmdListAds";
import { CommandSetAdMediaFile } from "./commands/cmdSetAdMedia";
import { CommandSetAdThumbnail } from "./commands/cmdSetAdThumbnail";

export class AdService {
  async getAd(adId: number, expand?: "children" | "content") {
    const cmd = new CommandGetAd();
    return cmd.run(adId, expand);
  }

  async listAds(adIds: number[]) {
    const cmd = new CommandListAds();
    return cmd.run(adIds);
  }

  async setAdThumbnail(adId: number, thumbnailFile: File, metadata: any) {
    const cmd = new CommandSetAdThumbnail();
    return cmd.run(adId, thumbnailFile, metadata);
  }

  async setAdMedia(adId: number, mediaFile: File, metadata: any) {
    const cmd = new CommandSetAdMediaFile();
    return cmd.run(adId, mediaFile, metadata);
  }

  async getAdComments(adId: number) {
    const cmd = new CommandGetAdComments();
    return cmd.run(adId);
  }
}
